<template />
<script>
export default {
  name: "Logout",
  created() {
    this.$store.dispatch("AUTH_LOGOUT");
    this.$router.push({ name: "Login" });
  }
};
</script>
